"use strict";import{Meter as e}from"./src/Meter.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-meter",e);
//# sourceMappingURL=sp-meter.js.map
